const styles = theme => ({
  ReturnRejectBox: {
    padding: '16px',
    color: '#342D3D',
    marginBottom: '16px',
    width: '100%',
    backgroundColor: theme.palette.primary.white,

    '& h6': {
      fontWeight: '500',
      marginBottom: '8px',
      fontSize: '16px',
    },
    '& p': {
      fontSize: '14px',
      fontWeight: '400',
    },
  },

  RedBox: {
    border: '1px solid #DF2C2C',
    '& h6': {
      color: '#DF2C2C',
    },
  },

  YellowBox: {
    border: `1px solid ${theme.palette.primary.warningMango}`,
    '& h6': {
      color: '#A76708',
    },
  },

  alert: {
    width: '100%',
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
  },

  alertText: {
    color: theme.palette.primary.adgmBlack,
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
  },

  alertEditBtn: {
    background: 'transparent !important',
    padding: 0,
    marginLeft: '4px',
    color: theme.palette.primary.adgmSkyBlue,
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '18px',
    textTransform: 'lowercase',

    '& .MuiButton-label span::first-letter': {
      textTransform: 'uppercase',
    },
  },
});

export default styles;
